import baseApi, { TAGS } from './baseApi';
import { captureException } from '@sentry/react';

/************************************************** API **************************************************/
const messagesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    sendInternalMessage: builder.mutation({
      query: ({ userId, text, attachments, mentionedBookkeeperIds }) => ({
        url: 'messages/internal',
        method: 'POST',
        body: { userId, text, attachments, mentionedBookkeeperIds }
      }),
      invalidatesTags: [
        TAGS.USER_MESSAGES,
        TAGS.USER_LIST,
        TAGS.NUM_BLUE_DOTS,
        TAGS.UNNOTICED_USERS,
        TAGS.USER_BOOKKEEPER_ASSIGNMENTS
      ]
    }),
    sendStreamMessage: builder.mutation({
      query: ({ userId, text, attachments }) => ({
        url: 'messages/stream',
        method: 'POST',
        body: { userId, text, attachments }
      }),
      invalidatesTags: [TAGS.USER_MESSAGES, TAGS.USER_LIST, TAGS.NUM_BLUE_DOTS, TAGS.UNNOTICED_USERS]
    }),
    getUserMessages: builder.query({
      query: (userId) => ({
        url: `messages/${userId}`,
        method: 'GET'
      }),
      transformResponse: (response) => {
        const rawMessages = response.data;
        return rawMessages.map((m) => {
          const isUserEscalation = m.bookkeeper == null && m.text_type?.startsWith('forcedEscalation -');
          return { ...m, delivered: true, ...(isUserEscalation && { className: 'user' }) };
        });
      },
      providesTags: [TAGS.USER_MESSAGES],
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (e) {
          captureException(e);
        }
      }
    }),
    getDataMistakeTypes: builder.query({
      query: () => ({
        url: 'messages/data-mistake/types',
        method: 'GET'
      }),
      transformResponse: (response) => response.data
    }),
    recordDataMistake: builder.mutation({
      query: ({ mistakeTypeId, smsId, comments }) => ({
        url: 'messages/data-mistake',
        method: 'POST',
        body: { mistakeTypeId, smsId, comments }
      })
    }),
    importMessageToQDeck: builder.mutation({
      query: ({ userId, authorEmail, authorName, authorType, text, timestamp }) => ({
        url: 'messages/qdeck/import',
        method: 'POST',
        body: {
          userId,
          authorEmail,
          authorName,
          authorType,
          text,
          timestamp
        }
      })
    })
  })
});

/************************************************** HOOKS **************************************************/
export const {
  useSendInternalMessageMutation,
  useSendStreamMessageMutation,
  useGetUserMessagesQuery,
  useGetDataMistakeTypesQuery,
  useRecordDataMistakeMutation,
  useImportMessageToQDeckMutation
} = messagesApi;
